import { useRef, useState } from 'react';
import { API_ROUTES, clearFlashMessages, DEVICES_LIST, setFlashMessage, userIsLogged } from '../../../helpers';
import HousePilotDeviceBox from './Device_Box';

import $ from 'jquery';
import HousePilotDeviceBoxCE from './Device_Box_CE';
import HousePilotDeviceBoxSS from './Device_Box_SS';
import House from '../House';
let mainMode = ''
const REFRESH_INTERVAL = 30 * 1000
let lastUpdateDate


export class HousePilotManager {

    loadDeviceDataIntoTemplate(clearCache = false) {
        this.loadDevicesData(clearCache).then((data) => {
            if (data) {
                if (JSON.stringify(this._devicesData) !== JSON.stringify(data.devicesData)) {
                    this._setDevicesData(data.devicesData)
                }
         
                if (JSON.stringify(this._weatherData) !== JSON.stringify(data.weather)) {
                    this._setWeatherData(data.weather)
                }
               
            }
        })
    }

    async changeMode(newMode) {
        mainMode = newMode
        await this.requestChangeState('MAIN', 'SET_MODE', newMode)
    }

    async requestChangeState(deviceName, operationName, operationValue) {
        return new Promise((resolve, reject) => {
            const deviceLabel = DEVICES_LIST.find(o => o.name === deviceName).label || deviceName
            $.post(API_ROUTES.DEVICES_CHANGE_STATE, {
                deviceName: deviceName,
                operation: operationName,
                value: operationValue
            }, (data) => {
                let flashMessage
                if (operationName === 'SET_TEMP') {
                    flashMessage = deviceLabel + ' : '
                    let temperatureMsgPart = 'température changée à ' + operationValue + ' °C'
                    if (data.state === 'STOP') {
                        flashMessage += 'arrêté'
                    } else if (data.state === 'START') {
                        flashMessage += 'démarré et ' + temperatureMsgPart
                    } else {
                        flashMessage += temperatureMsgPart
                    }
                }
                if (operationName === 'SET_MODE') {
                    flashMessage = 'Mode pour ' + deviceLabel + ' changé à ' + operationValue.toUpperCase();
                }
                if (deviceName == 'SPA') {
                    flashMessage = 'Opération <b>' + operationName + '</b> à ' + operationValue.toUpperCase() + ' effectuée pour le SPA';
                }
                setFlashMessage('success', flashMessage)
                resolve()
                this.loadDeviceDataIntoTemplate()
            }
            ).fail(error => {
                let msg = 'Echec du changement de statut pour <b>' + deviceName + '</b> operation <b>' + operationName + '</b> avec paramètre <b>' + operationValue + '</b>, <br/>Trace :';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' ' + JSON.stringify(error.responseJSON.output);
                }
                setFlashMessage('error', msg);
                reject()
            }).always(() => {

            });
        })
    }

    async loadDevicesData(clearCache = false) {
        return new Promise((resolve, reject) => {
            let url = API_ROUTES.DEVICES_GET_DATA
            if (clearCache === true) {
                url += '?cc=true'
            }
            $.get(url, (data) => {
                lastUpdateDate = 'Actualisé ' + data.meta.date
                resolve(data)
                if ($('#flashMessages div').first().text().includes('Echec du chargement des données')) {
                    clearFlashMessages()
                }
            }
            ).fail(error => {
                let msg = 'Echec du chargement des données (Chauffage - Climatisation)';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' : ' + error.responseJSON.output;
                }
                setFlashMessage('error', msg);
                resolve()
            }).always(() => {
            });
        })
    }



    getDevicesBoxTemplate() {
        const devicesData = this._devicesData
        if (!devicesData) {
            return
        }
        const devicesBoxTemplatesList = Object.keys(devicesData).map((deviceName) => {
            if (deviceName.startsWith('R_')) {
                const deviceData = devicesData[deviceName]
                return (<HousePilotDeviceBox key={deviceName} isActive={Boolean(deviceData.isActive)} deviceName={deviceName} deviceLabel={deviceData.label} deviceCurrentTemp={deviceData.temperatureState} deviceTargetTemp={deviceData.targetTemperature} onStateChange={onStateChange} />)
            } else if (deviceName === 'O_CE') {
                const dataCE = devicesData['O_CE']
                return (<HousePilotDeviceBoxCE key={deviceName} deviceName={deviceName} deviceLabel='CHAUFFE-EAU' isActive={dataCE.isActive} currentTemp={dataCE.middleWaterTemperatureState} targetTemp={dataCE.temperatureState} consoTotal={dataCE.deviceConsoToday / 1000}
                    progPump={dataCE.operatingRangeState} progPumpDetails={dataCE.prog} pumpHeat={dataCE.powerHeatPumpState} _isBoostActive={dataCE.boostMode} _isAbsenceMode={dataCE.operatingModeState.absence === 'on'} />)
            } else if (deviceName === 'O_SS') {
                const dataSS = devicesData['O_SS']
                return (<HousePilotDeviceBoxSS key={deviceName} deviceName={deviceName} deviceLabel={dataSS.label} mode={dataSS.targetHeatingLevelState} onStateChange={onStateChange} />)
            } else {
                return (<span key={deviceName}></span>)
            }
        })
        return devicesBoxTemplatesList
    }

    clearDataCache() {
        this.loadDeviceDataIntoTemplate(true)
    }
}

const manager = new HousePilotManager()

async function onStateChange(deviceName, operationName, operationValue) {
    await manager.requestChangeState(deviceName, operationName, operationValue)
    manager.loadDeviceDataIntoTemplate()
}


export default function HousePilot() {

    const [isLogged, setIsLogged] = useState(false)
    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                window.location.href = process.env.REACT_APP_HOST + '/common/login'
            }
            setIsLogged(isLogged)
        })
    }

    const [devicesData, setDevicesData] = useState(null)
    const [weatherData, setWeatherData] = useState(null)
    let refRefreshIntervalId = useRef(null)

    manager._devicesData = devicesData
    manager._setDevicesData = setDevicesData
    manager._setWeatherData = setWeatherData

    if (devicesData === null) {
        manager.loadDeviceDataIntoTemplate()
    }

    if (refRefreshIntervalId?.current === null) {
        refRefreshIntervalId.current = setInterval(() => {
            manager.loadDeviceDataIntoTemplate()
        }, REFRESH_INTERVAL)
    }

    function isLoaded() {
        return devicesData !== null
    }

    const devicesBox = manager.getDevicesBoxTemplate()


    if (isLogged) {
        return (
            <>
                <House activeTab="pilotage" />
                <div className="conteneur">
                    <div id="flashMessages"></div>

                    <div id="loader" className="text-center" style={{ display: isLoaded() ? 'none' : 'block' }}>
                        <img style={{ marginTop: "3rem", maxWidth: "128px" }} src={require('../../../resources/img/loader3.gif')} />
                    </div>
                    <div id="devicesDataPart" className="text-center" style={{ display: isLoaded() ? 'block' : 'none' }} >
                        <h4 className="">Chauffage - Climatisation</h4>
                        <div className='row'>
                            <div className="ml-4  deviceBox  col-10 col-md-6'" style={{ background: '#13617e' }}>
                                SHOGUN : <strong>{devicesData && devicesData['MAIN'] && devicesData['MAIN']?.powerInfo?.consoToday ? (devicesData['MAIN']?.powerInfo?.consoToday / 1000).toFixed(1) : '--'} kWh </strong>
                                | <strong>{devicesData && devicesData['MAIN'] && devicesData['MAIN']?.powerInfo?.values?.P ? (devicesData['MAIN']?.powerInfo?.values?.P / 1000).toFixed(1) : '--'} kWh </strong>
                                <span>(
                                    {/* {devicesData && devicesData['MAIN'] && devicesData['MAIN']?.powerInfo?.values?.V? (devicesData['MAIN']?.powerInfo?.values?.V).toFixed(0) : '--'} V |  */}
                                    {devicesData && devicesData['MAIN'] && devicesData['MAIN']?.powerInfo?.values?.A ? (devicesData['MAIN']?.powerInfo?.values?.A).toFixed(1) : '--'} A)
                                </span>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="ml-4  deviceBox  col-10 col-md-6'" style={{ background: 'rgb(82 113 24)' }}>
                                INT : <strong>{weatherData && weatherData['IN'] && weatherData['IN']?.temperature ? (weatherData['IN']?.temperature).toFixed(1) : '--'} °C</strong> | 
                                HR : <strong>{weatherData && weatherData['IN'] && weatherData['IN']?.humidity ? (weatherData['IN']?.humidity).toFixed(0) : '--'} %</strong> | 
                                C02 : <strong>{weatherData && weatherData['IN'] && weatherData['IN']?.co2 ? (weatherData['IN']?.co2).toFixed(0) : '--'} ppm</strong>
                                <br/>
                                EXT : <strong>{weatherData && weatherData['OUT'] && weatherData['OUT']?.temperature ? (weatherData['OUT']?.temperature).toFixed(1) : '--'} °C</strong> | 
                                HR : <strong>{weatherData && weatherData['OUT'] && weatherData['OUT']?.humidity ? (weatherData['OUT']?.humidity).toFixed(0) : '--'} %</strong> | 
                                PLU : <strong>{weatherData && weatherData['RAIN'] && weatherData['RAIN']?.sum_1h ? (weatherData['RAIN']?.sum_1h).toFixed(0) : '--'}</strong>/
                                <strong>{weatherData && weatherData['RAIN'] && weatherData['RAIN']?.sum_24h ? (weatherData['RAIN']?.sum_24h).toFixed(0) : '--'}</strong> mm
                            </div>
                        </div>
                        <div className="d-none alert alert-warning" id="coreErrorState"></div>

                        <div className="text-center my-2" id="mainMode" >
                            <select className="form-control d-inline-block" style={{ maxWidth: "250px" }} onChange={(e) => { changeMode(e.target.value) }} defaultValue={mainMode}>
                                <option value="heating"> Mode Chauffage</option>
                                <option value="cooling"> Mode Climatisation</option>
                                <option value="stop">Arrêt</option>
                            </select>
                        </div>

                        <div className="row ml-1 mr-1 mb-3" id="deviceBoxes">
                            {devicesBox}

                        </div>

                        <div className="text-center small"><span id="tableDateUpdate">{lastUpdateDate} </span>
                            <img onClick={() => { manager.loadDeviceDataIntoTemplate() }} src={require('../../../resources/img/refresh.png')} className="cursor-pointer"
                                style={{ width: "24px" }} alt="Forcer à rafraichir" />
                        </div>
                        <div className="text-center">
                            <button onClick={() => { manager.clearDataCache() }} className="btn btn-secondary btn-sm btn-warn">Vider le cache</button>
                        </div>
                    </div>
                    <hr />
                </div>

            </>)
    }
}
